import { render, staticRenderFns } from "./photoSwipe.vue?vue&type=template&id=33c71a38"
import script from "./photoSwipe.vue?vue&type=script&lang=js"
export * from "./photoSwipe.vue?vue&type=script&lang=js"
import style0 from "./photoSwipe.vue?vue&type=style&index=0&id=33c71a38&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c71a38')) {
      api.createRecord('33c71a38', component.options)
    } else {
      api.reload('33c71a38', component.options)
    }
    module.hot.accept("./photoSwipe.vue?vue&type=template&id=33c71a38", function () {
      api.rerender('33c71a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoSwipe.vue"
export default component.exports